import { FaTrash, FaDownload } from "react-icons/fa";
import api from "../../../../../utils/axiosInstance";
import { toast } from "../../../../../components/Toast/toast";

const ProjectInputFilesCard = ({ files = [], loading, onDelete, onUpload, onRefresh }) => {
  const formatSize = (bytes) => {
    if (!bytes) return "-";
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(2)} KB`;
    return `${(kb / 1024).toFixed(2)} MB`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  const getUploaderName = (doc) => {
    const details = doc.uploader?.details;
    if (details?.first_name) return `${details.first_name} ${details.last_name}`;
    if (doc.uploader?.email) return doc.uploader.email;
    return "-";
  };

  const handleDownload = async (doc) => {
    try {
      const response = await api.get(
        `/download-file?path=${encodeURIComponent(doc.file_path)}`,
        { responseType: "blob" }
      );
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = doc.original_file_name || "file";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download file");
    }
  };

  const HEADERS = ["Code", "File Name", "Category", "Note", "Size", "Uploaded At", "Uploaded By", "Actions"];

  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="font-bold text-gray-900">
          Project Input Files <span className="text-gray-500 font-medium">({files.length})</span>
        </h2>
        <div className="flex items-center gap-2 text-sm">
          <button
            onClick={onUpload}
            className="px-3 py-1.5 font-medium text-white bg-blue-600 hover:bg-blue-700 rounded"
          >
            Upload
          </button>
          <button
            onClick={() => toast.error("Add URL feature coming soon!")}
            className="px-3 py-1.5 font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded"
          >
            Add URL
          </button>
        </div>
      </div>

      <div className="w-full bg-white shadow rounded-lg overflow-hidden">
        <div className="max-h-[300px] overflow-y-auto overflow-x-auto">
          {loading ? (
            <div className="flex justify-center py-10">
              <div className="animate-spin rounded-full h-8 w-8 border border-gray-300 border-t-blue-600" />
            </div>
          ) : (
            <table className="w-full table-auto border-collapse">
              <thead className="sticky top-0 z-10">
                <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
                  {HEADERS.map((h) => (
                    <th key={h} className="px-3 py-2 text-center font-semibold whitespace-nowrap">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {files.length === 0 ? (
                  <tr>
                    <td colSpan={HEADERS.length} className="py-10 text-center text-gray-400 text-xs">
                      No project input files found. Upload files to get started.
                    </td>
                  </tr>
                ) : (
                  files.map((doc, index) => {
                    const rowBg = index % 2 === 0 ? "bg-gray-50" : "bg-white";
                    return (
                      <tr key={doc.id} className={`${rowBg} hover:bg-blue-50 transition-colors`}>
                        <td className="px-3 py-2 text-xs text-center whitespace-nowrap text-gray-700">
                          {doc.file_code}
                        </td>
                        <td className="px-3 py-2 text-xs text-center break-words">
                          <button
                            onClick={() => handleDownload(doc)}
                            className="text-blue-600 hover:text-blue-800 underline font-medium"
                          >
                            {doc.original_file_name}
                          </button>
                        </td>
                        <td className="px-3 py-2 text-xs text-center whitespace-nowrap text-gray-700">
                          {doc.category || "—"}
                        </td>
                        <td className="px-3 py-2 text-xs text-center whitespace-nowrap text-gray-700">
                          {doc.note || "—"}
                        </td>
                        <td className="px-3 py-2 text-xs text-center whitespace-nowrap text-gray-700">
                          {formatSize(doc.file_size)}
                        </td>
                        <td className="px-3 py-2 text-xs text-center whitespace-nowrap text-gray-500">
                          {formatDate(doc.uploaded_at)}
                        </td>
                        <td className="px-3 py-2 text-xs text-center whitespace-nowrap text-gray-700">
                          {getUploaderName(doc)}
                        </td>
                        <td className="px-3 py-2 text-xs text-center whitespace-nowrap">
                          <div className="flex items-center justify-center gap-3">
                            <button
                              onClick={() => handleDownload(doc)}
                              className="text-gray-400 hover:text-blue-600 transition-colors"
                              title="Download"
                            >
                              <FaDownload />
                            </button>
                            <button
                              onClick={() => onDelete(doc.id)}
                              className="text-gray-400 hover:text-red-600 transition-colors"
                              title="Delete"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectInputFilesCard;